import { render, staticRenderFns } from "./LongTermCare.vue?vue&type=template&id=7fe96a27"
import script from "./LongTermCare.vue?vue&type=script&lang=js"
export * from "./LongTermCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports